import { OpenInNew } from '@mui/icons-material';
import { Button, Link } from '@mui/material';
import { useTranslation } from 'react-i18next';

import { I18nNamespace } from '~/common/types';

interface SmartLinksExternalButtonProps {
  href: string;
}

export const SmartLinksExternalButton = ({ href }: SmartLinksExternalButtonProps) => {
  const { t } = useTranslation(I18nNamespace.common, { keyPrefix: 'SmartLinks' });

  return (
    <Link href={href} target="_blank">
      <Button endIcon={<OpenInNew />}>{t('openInNewTab')}</Button>
    </Link>
  );
};
